import { ChevronLeft, Clock } from 'lucide-react';
import { useState } from 'react';
import { reminderPresets, toDateTimeLocal } from '../../lib/dates';
import { requestNotificationPermission } from '../../hooks/use-reminder-notifications';

/** Choix d'un rappel : préréglages de Keep ou date et heure personnalisées. */
export function ReminderPicker({
  value,
  onChange,
  onDone,
}: {
  value: string | null;
  onChange: (reminderAt: string | null) => void;
  onDone?: () => void;
}) {
  const [custom, setCustom] = useState(false);
  const initial = value ? new Date(value) : new Date(Date.now() + 60 * 60 * 1000);
  const [local, setLocal] = useState(toDateTimeLocal(initial));

  const pick = (date: Date) => {
    void requestNotificationPermission();
    onChange(date.toISOString());
    onDone?.();
  };

  if (custom) {
    return (
      <form
        className="flex w-72 flex-col gap-3 p-4"
        onSubmit={(event) => {
          event.preventDefault();
          const date = new Date(local);
          if (!Number.isNaN(date.getTime())) pick(date);
        }}
      >
        <button
          type="button"
          className="flex items-center gap-1 text-sm text-muted hover:text-fg"
          onClick={() => setCustom(false)}
        >
          <ChevronLeft size={18} /> Choisir la date et l'heure
        </button>
        <input
          type="datetime-local"
          value={local}
          onChange={(event) => setLocal(event.target.value)}
          required
          className="rounded border border-line bg-transparent px-2 py-2 text-sm"
        />
        <div className="flex justify-end">
          <button
            type="submit"
            className="rounded px-4 py-2 text-sm font-medium text-primary hover:bg-hover"
          >
            Enregistrer
          </button>
        </div>
      </form>
    );
  }

  return (
    <div className="w-72 py-2 text-sm">
      <div className="px-4 pt-1 pb-2 font-medium">Rappel :</div>
      {reminderPresets().map((preset) => (
        <button
          key={preset.label}
          type="button"
          onClick={() => pick(preset.date)}
          className="flex h-9 w-full items-center justify-between px-4 hover:bg-hover"
        >
          <span>{preset.label}</span>
          <span className="text-muted">{preset.detail}</span>
        </button>
      ))}
      <button
        type="button"
        onClick={() => setCustom(true)}
        className="flex h-9 w-full items-center gap-3 px-4 hover:bg-hover"
      >
        <Clock size={18} className="text-muted" /> Choisir la date et l'heure
      </button>
      {value && (
        <button
          type="button"
          onClick={() => {
            onChange(null);
            onDone?.();
          }}
          className="mt-1 flex h-9 w-full items-center border-t border-line px-4 pt-1 text-danger hover:bg-hover"
        >
          Supprimer le rappel
        </button>
      )}
    </div>
  );
}
